{
  "title": "Меню",
  "links": {
    "aboutUs": "Про Healthy Mind",
    "terms": "Умови використання",
    "privacy": "Політика обробки даних",
    "contactUs": "Напишіть нам"
  },
  "email": "info@healthymind.help",
  "copyright": "Всі права захищені © {{year}}",
  "disclaimer": "Результати діагностики мають інформаційний характер і не є діагнозом. За потреби вони можуть стати приводом для консультації з фахівцем з ментального здоров’я."
}
